
import { Vue, Component } from 'vue-property-decorator'
import ConstructionWorker from '@/types/constructionWorker'

@Component({
  components: {}
})

export default class ConstructionWorkerEditDetailsTab extends Vue {
  settings = {
    routeNames: { list: 'constructionWorkers', show: 'constructionWorkerShow', edit: 'constructionWorkerEdit' },
    routeParamKey: 'constructionWorkerId',
    functionNames: { setCurrent: 'setCurrentConstructionWorker', save: 'saveConstructionWorker' },
    getterNames: { current: 'currentConstructionWorker', loading: 'loadingConstructionWorker', errors: 'constructionWorkerErrors' }
  }

  get currentItem () : ConstructionWorker {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }
}
